import "./Index.css";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { useMemo } from "react";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const Linechart = ({ dataset, mode }) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: false,
        text: "Chart.js Line Chart",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text:
            mode === "MONTH"
              ? "X -AXIS ---> DATES IN A MONTH"
              : "X -AXIS ---> MONTHS IN A YEAR",
        },
      },
      y: {
        title: {
          display: true,
          text: "Y-AXIS ---> VISITORS COUNT",
        },
        ticks: {
          callback: function (value) {
            return Number.isInteger(value) ? value : "100";
          },
          stepSize: 1,
        },
      },
    },
  };

  const chartData = useMemo(() => {
    const data = [];
    const labels = [];
    if (dataset && dataset.length > 0) {
      dataset.forEach((item, index) => {
        data.push(item?.value);
        labels.push(item?.label); // You can customize this
      });
    }
    return { data, labels };
  }, [dataset]);

  const data = {
    labels: chartData.labels,
    datasets: [
      {
        fill: true,
        data: chartData.data,
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  return <Line options={options} data={data} className="line_charts" />;
};
export default Linechart;
